import React, { Fragment, useEffect, useState } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Typography } from "@mui/material";
import theme from "../../theme";
import CommonButton from "../../common/components/CommonButton";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import { setLoading } from "../../features/authSlice";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { getUpcomingSession } from "../../api/sessionApi";
import { ServiceOffer, serviceOptions, ServiceTypes, SkillPath, UserTypeId } from "../../common/const";
import { ArrowDropDown, } from "@mui/icons-material";
import CommonBookSession from "../../common/components/CommonBookSession";
import { useNavigate } from "react-router-dom";

const Events = ({
    tutoringType,
    studentId,
    pathname,
    subService,
    setInitialData
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user, loading } = useSelector((state) => state.auth);
    const [days, setDays] = useState([]);
    const [eventDate, setEventDate] = useState(null);
    const [events, setEvents] = useState([]);
    const [selectedSession, setSelectedSesion] = useState(null);
    const [open, setOpen] = useState(false);
   
    const getNextSevenDays = () => {
        const dates = [];
        for (let i = 0; i < 7; i++) {
            dates.push(moment().add(i, 'days').format('YYYY-MM-DD'));
        }
        setDays(dates);
        setEventDate(dates[0]);
    };

    useEffect(() => {
        getNextSevenDays();
    }, [tutoringType, subService]);

    const getEvents = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getUpcomingSession(pathname === SkillPath ? ServiceOffer.skillCoach : ServiceTypes[tutoringType], studentId, subService);
            setEvents(response?.data?.filter((a) => moment(a?.session_start_time)?.isSame(eventDate, 'day')));
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        if (user?.user_id) {
            getEvents();
        }
    }, [user?.user_id, eventDate, tutoringType, subService]);

    return (
        <Fragment>
            {loading && (
                <LoadingSpinner />
            )}
            <CommonBookSession
                bookingUrl={selectedSession?.reschedule_url}
                open={open}
                setOpen={setOpen}
                handleClose={(data) => {
                    setOpen(false);
                    setInitialData(data);
                }}
            />
            <CommonCard
                borderRadius={2}
                border={`1px solid #0000001A`}
                headerContent={
                    <Fragment>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{ padding: '13px' }}
                        >
                            <Box>
                                <Typography fontWeight={600}>Upcoming Session</Typography>
                                <Typography fontSize={14} color={theme.palette.background.dark}>View and join your scheduled classes and test sessions.</Typography>
                            </Box>
                            <CommonButton
                                label="View More"
                                marginBottom="0px"
                                width="150px"
                                height="30px"
                                background={theme.palette.background.main}
                                color={theme.palette.background.dark}
                                borderRadius={3}
                                endIcon={<ArrowDropDown sx={{ color: theme.palette.background.dark }} />}
                                fontWeight={600}
                                handleClick={() => navigate('/my-dcp-calendar')}
                            />
                        </Box>
                    </Fragment>
                }
                content={
                    <Box>
                        <Box
                            display="flex"
                            gap={1}
                            mb={2}
                        >
                            {days.map((a) => (
                                <Box
                                    sx={{
                                        background: eventDate === a ? theme.palette.primary.main : theme.palette.background.main,
                                        borderRadius: 1,
                                        padding: 1,
                                        width: '70px',
                                        cursor: 'pointer',
                                        border: `1px solid ${theme.palette.background.secondary}`
                                    }}
                                    onClick={() => {
                                        setEventDate(a);
                                    }}
                                >
                                    <Typography fontSize={12} fontWeight={600} color={theme.palette.secondary.main} textAlign="center">{moment(a).format('ddd')}</Typography>
                                    <Typography fontSize={18} fontWeight={600} color={theme.palette.secondary.main} textAlign="center">{moment(a).date()}</Typography>
                                </Box>
                            ))}
                        </Box>
                        {events.length > 0 ? events.map((a, index) => {
                            return (
                                <CommonCard
                                    key={index}
                                    background={theme.palette.background.main}
                                    borderRadius={2}
                                    paddingBottom="0px"
                                    padding="13px"
                                    marginTop={index === 0 ? "0px" : "10px"}
                                    content={
                                        <Box
                                            display="flex"
                                            flexDirection={{ xs: 'column', sm: 'row' }}
                                            justifyContent="space-between"
                                            alignItems={{ xs: 'stretch', sm: 'center' }}
                                            gap={{ xs: 2, sm: 0 }}
                                        >
                                            <Box
                                                display="flex"
                                                gap={1}
                                                alignItems="center"
                                                flex={{ xs: 'none', sm: 1 }}
                                            >
                                                <Box
                                                    sx={{
                                                        background: theme.palette.secondary.main,
                                                        borderRadius: 1,
                                                        padding: 1,
                                                        width: { xs: '55px', sm: '65px' },
                                                        cursor: 'pointer',
                                                        border: `1px solid ${theme.palette.background.secondary}`,
                                                        flexShrink: 0
                                                    }}
                                                >
                                                    <Typography
                                                        fontSize={{ xs: 17, sm: 19 }}
                                                        fontWeight={600}
                                                        color={theme.palette.primary.main}
                                                        textAlign="center"
                                                    >
                                                        {moment(a.session_start_time).date()}
                                                    </Typography>
                                                    <Typography
                                                        fontSize={{ xs: 10, sm: 11 }}
                                                        fontWeight={600}
                                                        color="White"
                                                        textAlign="center"
                                                    >
                                                        {moment(a.session_start_time).format('MMM YYYY')}
                                                    </Typography>
                                                </Box>

                                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                                    <Typography
                                                        fontSize={{ xs: 13, sm: 14 }}
                                                        fontWeight="600"
                                                        sx={{
                                                            wordBreak: 'break-word'
                                                        }}
                                                    >
                                                        {a.topic || serviceOptions?.find((i) => i.value === a.service_name)?.label}
                                                    </Typography>
                                                    <Typography
                                                        fontSize={{ xs: 12, sm: 13 }}
                                                        color={theme.palette.background.dark}
                                                    >
                                                        {`${moment(a.session_start_time).format('hh:mm A')} - ${moment(a.session_end_time).format('hh:mm A')}`}
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            {/* Button Container */}
                                            {user?.user_type_id === UserTypeId.Student && (
                                            <Box
                                                display="flex"
                                                gap={1}
                                            >
                                                {a.meeting_link !== null && (
                                                    <CommonButton
                                                        marginBottom="0px"
                                                        label="Join Session"
                                                        width="120px"
                                                        height="30px"
                                                        disabled={moment(a.session_start_time).diff(moment(), 'minutes') > 10}
                                                        handleClick={() => {
                                                            window.open(a.meeting_link)
                                                        }}
                                                    />
                                                )}
                                                <CommonButton
                                                    marginBottom="0px"
                                                    label="Reschedule"
                                                    width="100px"
                                                    height="30px"
                                                    disabled={moment(a.session_start_time).diff(moment(), 'minutes') < 10}
                                                    color={theme.palette.background.dark}
                                                    background="Transparent"
                                                    border={`1px solid #0000001A`}
                                                    handleClick={() => {
                                                        setSelectedSesion(a);
                                                        setOpen(true);
                                                    }}
                                                />
                                            </Box>)}
                                        </Box>
                                    }
                                />
                            )
                        }) : (
                            <Typography textAlign="center" color={theme.palette.background.dark}>No Session Found</Typography>
                        )}
                    </Box>
                }
                paddingBottom="0px"
                padding="13px"
                marginTop="0px"
            />
        </Fragment>
    )
}

export default Events;
